module.exports = __webpack_public_path__ + "static/generator-2ca568d3f2a4ce5be996b4c94be85bba.jpg";